



















































































import { defineComponent, reactive, toRefs, ref, onMounted, watch } from '@vue/composition-api';
import http from "../../plugins/http"
import moment from 'moment'
import * as Common from "../../commons/common"
import { BModal } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue"
import SumupResultRankTab from "../../components/SumupResultRankTab.vue"
import { SumupGroup, RankResult, AverageResult } from "../../modules/teacher/SumupResultRankListCurriculum"

export interface Data {
  sumup_group_id: string
  curriculum_id: string
  sumupGroup: SumupGroup
  rankResults: RankResult[]
  averageResult: AverageResult
  additionTarget: RankResult
  fields: any[]
  isAllChecked: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-result-rank-tab": SumupResultRankTab,
    "alert-area": AlertArea,
  },
  setup(_, context){

    const modalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: "",
      curriculum_id: "",
      sumupGroup: null,
      rankResults: [],
      averageResult: null,
      additionTarget: null,
      fields: [
        {key: "student_no_character", label: "受験番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "addition", label: "備考", sortable: true, class: 'text-center b-table-th-td'},
        {key: "score", label: "得点", sortable: true, class: 'text-center b-table-th-td', formatter: 'scoreFormatter'},
        {key: "rank", label: "順位", sortable: true, class: 'text-center b-table-th-td', formatter: 'rankFormatter'},
        {key: "std_score", label: "偏差値", sortable: true, class: 'text-center b-table-th-td'},
        {key: "isSelected", label: "答案", sortable: false, class: 'text-center b-table-th-td'},
      ],
      isAllChecked: false,
      errors: new Array<string>(),
    });

    /******************************
     * 備考モーダル表示
     ******************************/

    const showAdditionModal = (target: RankResult) => {
      state.additionTarget = target;
      modalRef.value.show();
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    /******************************
     * 一覧得点列のフォーマッター
     ******************************/

    const scoreFormatter = (value: any) => {
      return `${value}点`;
    }

    /******************************
     * 一覧順位列のフォーマッター
     ******************************/

    const rankFormatter = (value: any) => {
      return `${value}位`;
    }

    /******************************
     * 戻る矢印アイコン押下
     ******************************/

    const goSumupList = () => {
      context.root.$router.push("/teacher_site/sumup_list");
    };

    /******************************
     * 答案DL列ヘッダーCheckBoxの監視
     ******************************/

    watch(() => state.isAllChecked, (newVal, oldVal) => {
      state.rankResults.forEach(x => x.isSelected = newVal);
    });

    const download = async () => {

      const studentNoCharacters = state.rankResults.filter(x => x.isSelected).map(x => x.student_no_character);
      if(studentNoCharacters.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(studentNoCharacters.length > 100){
        if(!window.confirm("答案をダウンロードします。100名単位で複数回ダウンロード処理が実行されますので、途中で画面を閉じないでください。よろしいですか？")){
          return;
        }
      }else{
        if(!window.confirm("答案をダウンロードします。よろしいですか？")){
          return;
        }
      }

      context.root.$store.dispatch("showOverlay", {isShowProgress: true});

      const splitStudentNoCharacters = Common.arraySplit(studentNoCharacters, 100);

      let completedCount = 0;

      for(let i = 0; i < splitStudentNoCharacters.length; i++){
        await http.post(`/api/teacher/sumup_result_rank_list_curriculum/download_pdf/${state.sumup_group_id}/${state.curriculum_id}`, {student_no_characters: splitStudentNoCharacters[i]}, {responseType: 'arraybuffer'}).then(response => {
          const blob = new Blob([response.data], { type: 'application/zip' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `${state.sumupGroup.name}_${context.root.$store.getters.getCurriculumNameById(state.curriculum_id)}_${i + 1}.zip`;
          a.click();

          completedCount++;
          context.root.$store.commit("setProgressText", Number.parseFloat(`${completedCount * 100 / splitStudentNoCharacters.length}`).toFixed(2));
        })
        .catch(error=>{
          if(error.response.status == 422){
            const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
            state.errors = errorData.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          return;
        }
      }

      await resolveAfterMilliSeconds();

      alert("処理が完了しました。");
      
      context.root.$store.dispatch("hideOverlay");
    }

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      //context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.curriculum_id = context.root.$route.params.curriculum_id == null ? "" : context.root.$route.params.curriculum_id;
      await http.get(`/api/teacher/sumup_result_rank_list_curriculum?sumup_group_id=${state.sumup_group_id}&curriculum_id=${state.curriculum_id}`).then(response => {
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.rankResults = response.data.rank_results.map((x: any) => new RankResult(x));
        state.averageResult = new AverageResult(response.data.average_result);
        state.additionTarget = state.rankResults[0];

        if(state.sumupGroup.passing_score != null){
          state.fields.push({key: "passing_text", label: "合否", sortable: true, class: 'text-center b-table-th-td'});
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      modalRef,
      convertExecDate,
      goSumupList,
      scoreFormatter,
      rankFormatter,
      showAdditionModal,
      download,
    };
  }
});
